module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="hotspot_marker_container" style="left: ' +
((__t = ( left )) == null ? '' : __t) +
'%; top: ' +
((__t = ( top )) == null ? '' : __t) +
'%;">\n	<button class="hotspot_marker" aria-label="' +
((__t = ( I18n.t('lightbox.hotspot_product', { productName: productName }) )) == null ? '' : __t) +
'"></button>\n</div>';

}
return __p
}